import type { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { ChatCompletions } from "../../../ChatCompletions";
import { setMessages } from "../../../ChatCompletions/redux/slice";
import { ClearButton } from "../../../Components/Buttons/ClearButton";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (type: TModalsIds) => void;
}

export const ChatModal = ({ closeModal, ...props }: Props) => {
  const dispatch = useAppDispatch();
  const askGpt = useModalSelectors("ask_gpt_modal");
  const { t } = useTranslation();

  const handleClearChat = () => {
    dispatch(setMessages([]));
  };

  return (
    <ModalBasic
      open={askGpt.isOpen}
      title={t("chat_modal.title")}
      closeModal={() => closeModal("ask_gpt_modal")}
      onClose={() => closeModal("ask_gpt_modal")}
      hasHeaderPaddingBottom
      hasCloseButton
      className={styles["chat-modal"]}
      {...props}
    >
      <div className={styles["content-header"]}>
        <ClearButton
          iconType={"broom"}
          typeBtn={"text_btn"}
          onClick={handleClearChat}
          isDisabled={false}
          className={styles.clear}
        />
      </div>
      <ChatCompletions className={styles.chat} />
    </ModalBasic>
  );
};
